import { render, staticRenderFns } from "./userManagementDetail.vue?vue&type=template&id=253f4efc&"
import script from "./userManagementDetail.vue?vue&type=script&lang=js&"
export * from "./userManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./userManagementDetail.vue?vue&type=style&index=0&id=253f4efc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports